exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VehicleOverlayMarker_root_32nde {\n  position: relative;\n}\n\n.VehicleOverlayMarker_clickable_D03Ox {\n  cursor: pointer;\n}\n\n.VehicleOverlayMarker_labelWrapper_1qoXf {\n  position: absolute;\n  top: -32px;\n  left: 50%;\n}\n\n.VehicleOverlayMarker_label_37GNl {\n  font-size: 12px;\n  background-color: #4A90E2;\n  border-radius: 17px;\n  padding: 5px 8px;\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);\n  color: white;\n  font-weight: 500;\n  border: 3px solid white;\n  white-space: nowrap;\n  margin-left: -50%;\n  margin-right: 50%;\n}\n", ""]);

// exports
exports.locals = {
	"root": "VehicleOverlayMarker_root_32nde",
	"clickable": "VehicleOverlayMarker_clickable_D03Ox",
	"labelWrapper": "VehicleOverlayMarker_labelWrapper_1qoXf",
	"label": "VehicleOverlayMarker_label_37GNl"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/common/components/VehicleOverlayMarker/VehicleOverlayMarker.css
// module id = 1013
// module chunks = 0 1